export default __webpack_public_path__ + "static/media/01_launch.e311ef39.png";